export default "__VITE_ASSET__4e7b9ae0__"